import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, ArrowLeft, KeyRound, Send } from 'lucide-react';
import api from '../../api/axios';
import styles from './ForgotPassword.module.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      await api.post('/forgot-password', { email });
      navigate('/verify-code', { state: { email } });
    } catch (err) {
      console.error('Forgot password error:', err);
      if (err.response?.status === 422) {
        setError('We couldn\'t find an account with that email address.');
      } else {
        setError('Something went wrong. Please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles['forgot-password-page']}>
      <div className={styles['forgot-password-card']}>
        <div className={styles['card-header-banner']}>
          <h1 className={styles['title']}>Forgot Password?</h1>
        </div>

        <div className={styles['card-content']}>
          <p className={styles['subtitle']}>
            Enter your email address below and we'll send you a 6-digit verification code to reset your password.
          </p>

          {error && <div className={styles['error-message']}>{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className={styles['form-group']}>
              <label className={styles['form-label']} htmlFor="email">
                Email Address
              </label>
              <div className={styles['input-wrapper']}>
                <span className={styles['input-icon']}>
                  <Mail size={18} />
                </span>
                <input
                  id="email"
                  className={styles['form-input']}
                  type="email"
                  placeholder="admin@hariomelectricals.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <button type="submit" className={styles['submit-btn']} disabled={loading}>
              {loading ? 'Sending Code...' : (
                <>
                  Send Verification Code
                  <Send size={18} />
                </>
              )}
            </button>
          </form>

          <hr className={styles['divider']} />

          <Link to="/login" className={styles['back-link']}>
            <ArrowLeft size={16} /> Back to Login
          </Link>
        </div>
      </div>

    </div>
  );
};

export default ForgotPassword;
